export const enTranslation = {
      common: {
        loading: "Loading",
        loadingWithDots: "Loading...",
        error: "An error occurred",
        save: "Save",
        cancel: "Cancel",
        search: "Search",
        logout: "Log out",
        close: "Close",
        back: "Back",
        download: "Download",
        ascending: "Ascending",
        descending: "Descending",
        copy: "Copy",
        delete: "Delete",
        confirm: "Confirm",
        yes: "Yes",
        no: "No",
        select: "Select",
        deselect: "Deselect",
        selectAll: "Select all",
        noData: "No data",
        noImage: "No image",
        processing: "Processing...",
        uploading: "Uploading...",
        selectedCount: "Selected: {{count}}",
        downloading: "Downloading...",
        downloadCancel: "Cancel download",
        history: "History",
        done: "Done",
        input: "Input",
        import: "Import",
        overwrite: "Overwrite",
        value: "Value",
        register: "Register",
        comma: ", ",
      },
      apiError: {
        fetchFailed: "Failed to load data.",
        retryHint: "Reload the page or try again later.",
      },
      language: {
        japanese: "Japanese",
        english: "English",
        switchLabel: "Display language",
      },
      auth: {
        loginTitle: "Log in",
        email: "Email",
        password: "Password",
        loginNow: "Log in",
        forgotPassword: "Forgot your password?",
        emailRequired: "Enter your email address.",
        emailInvalid: "Enter a valid email address.",
        passwordRequired: "Enter your password.",
        loginFailed: "Login failed.",
        invalidCredentials: "Email address or password is incorrect.",
      },
      readonly: {
        description: "Editing and saving are disabled.",
        otherDepartment: "This sample belongs to another department and is read-only.",
        adminMode: "Admin mode is read-only.",
      },
      modal: {
        close: "Close modal",
      },
      sample: {
        guest: "Guest",
        partNumber: "Part number",
        sampleNumber: "Sample No.",
        sampleStatus: "Sample status",
        size: "Size",
        colorNo: "Color No.",
        repeat: "Repeat",
        department: "Department",
        deviceName: "Device name",
        measurementDate: "Measurement date",
        date: "Date",
        user: "User",
        customerName: "Customer name",
        color: "Color",
        departmentDropdown: "Department (dropdown)",
        allDepartments: "All departments",
        departmentLoading: "Loading departments",
        departmentFreeInput: "Department (free input)",
        departmentPartialSearch: "Search by department name",
        name: "Name",
        qrCode: "QR Code",
        qrConfirmation: "QR confirmation",
        measurementItem: "Measurement item",
        specDimension: "Spec dimension",
        measurementResult: "Measurement result",
        diff: "Difference",
        judgement: "Judgement",
        item: "Item",
        brand: "Brand",
        final: "Production",
        sample: "Sample",
        samplePhoto: "Measurement photo",
        ecPhoto: "EC photo",
        identificationResult: "Identification result",
        weightResult: "Weight result (g)",
        pastSamples: "Past samples",
      },
      actions: {
        backToMeasurement: "Back to measurement",
        filter: "Filter",
        filterSearch: "Filter search",
        bulkCsvDownload: "Bulk CSV download",
        qrDisplay: "Show QR",
        measurementDisplay: "Show measurement",
        showPastMeasurements: "Show past measurements",
        importSpecification: "Import specification",
        downloadMeasurementReport: "Download measurement report",
        downloadEcImages: "Download EC images",
        downloadPastMeasurementReport: "Download past measurement reports",
        showPastMeasurementsDescription: "View past measurement reports for this measurement",
        importSpecificationDescription: "Enter specified dimensions and compare them with measurements",
        downloadMeasurementReportDescription: "Download the current measurement report as a PDF",
        downloadEcImagesDescription: "Download only the captured EC images",
        downloadPastMeasurementReportDescription: "Download reports from previous measurements",
        measurementDateAsc: "Measurement date (ascending)",
        measurementDateDesc: "Measurement date (descending)",
        checkDimensions: "Check dimensions",
        urlQrSearch: "URL / QR search",
        clear: "Clear",
        add: "Add",
      },
      messages: {
        allDataLoaded: "All data has been loaded.",
        allSamplesLoaded: "All available samples have been loaded.",
        copyLinkSucceeded: "Link copied.",
        unsavedChanges: "Changes have not been saved.",
        unsavedChangesConfirm: "Your changes will be lost. Continue?",
        selectDownloadTarget: "Select a download target.",
        downloadFailedRetry: "Download failed. Please try again later.",
        pdfDownloadFailedRetry: "PDF download failed.\nPlease try again later.",
        filterDateNote: "Measurement date. You can search with either date.",
        qrScanGuide: "Scan the code with a QR scanner app or camera app on a smartphone.",
        downloadSelectionLimitExceeded: "You cannot download more than {{count}} selected items.",
        downloadProcessingFailedRetry: "An error occurred during download. Please try again later.",
        downloadTimeoutRetry: "Download timed out. Please try again later.",
        selectDownloadImages: "Select images to download.",
        loadingSamples: "Loading samples...",
        allReadableSamplesLoaded: "All readable samples have been displayed.",
        loadingSpecificationHistory: "Loading specification history...",
        allSpecificationHistoryLoaded: "All history has been loaded.",
        allDisplayableHistoryLoaded: "All displayable history has been loaded.",
        previewFetchFailed: "Failed to fetch preview.",
        previewLoadFailed: "Failed to load preview.",
        preparingPreview: "Preparing preview...",
        noPreview: "No preview is available.",
        representativeSampleMissing: "Could not get the representative sample ID.",
        previewAcquireFailed: "Failed to get preview.",
        downloadTargetNotSelected: "No download target is selected.",
        selectedGroupHasNoValidSample: "The selected group has no valid sample.",
        sampleNotFound: "The specified sample was not found.",
        sampleFetchFailed: "Failed to fetch the sample.",
        sampleSaveSucceeded: "Saved.",
        duplicateSampleExists: "The same sample already exists.",
        confirmInput: "Please check the entered values.",
        sampleSaveFailed: "Save failed.",
        retrySaveButton: "Click the save button again.",
        measurementNameMissing: "Some measurement items do not have names.",
        relatedSampleNotFound: "No matching sample was found.",
        linkPastSamplesConfirm: "Link past samples as well?",
        linkPastSamplesNote: "This will not run until you save.",
        resolutionUnknown: "Could not identify the resolution. Check the device settings or sample data.",
        selectMeasurementImageForManual: "Select a measurement photo. Manual measurement is not available on EC images.",
        invalidResolution: "Measurement is unavailable because the resolution is invalid. Check the device settings or sample data.",
        selectMeasurementImageToAdd: "Select a measurement photo before adding a measurement point.",
        loadMeasurementImageBeforeManual: "Load a measurement photo and select the image before starting manual measurement.",
        deleteMeasurementItemConfirm: "Delete this measurement item?",
        restoreDeletedAutoMeasurementConfirm: "Restore the deleted automatic measurement point?",
        measurementItemAlreadyExists: "\"{{name}}\" already exists.",
        overwriteConfirm: "Overwrite it?",
        autoMeasurementOverwriteConfirm: "This is automatic measurement data.\nOverwrite it with manual measurement?",
        unnamedMeasurementExists: "A measurement point without a name already exists.",
        genericRegistrationFailed: "Registration failed.",
        valueEmpty: "The value is empty.",
        problemValue: "Problem value:",
        duplicateDataExists: "Duplicate data exists.",
        overwriteAndSaveConfirm: "Overwrite and save?",
        csvDuplicateMessage: "{{rows}} in the CSV duplicates existing data.",
        csvFixAndUpload: "Fix CSV{{rowText}} and upload it again.",
      },
      pages: {
        qrImage: "QR image",
        measurementEcImage: "Measurement / EC images",
        pastMeasurements: "Past measurements",
        measurementResults: "Measurement results",
        bulkSpecificationDownload: "Bulk specification download",
        specificationHistory: "Specification history",
        brandOption: "Brand option",
        shootingImage: "Captured images",
        specificationImport: "Specification import",
        specificationImportHistory: "Specification import history",
        specificationRegister: "Specification registration",
      },
      accessibility: {
        selectItem: "Select {{label}}",
        checkedCheckbox: "Checked checkbox",
        uncheckedCheckbox: "Unchecked checkbox",
        previewImage: "Preview image",
        showSizeCandidates: "Show size candidates",
        measurementImage: "Measurement image {{index}}",
      },
      placeholders: {
        partNumberInput: "Enter part number",
        sampleNumberInput: "Enter sample No.",
        sizeInput: "Enter size",
        colorInput: "Enter color",
        itemNameInput: "Enter item name",
        brandNameInput: "Enter brand name",
        pants: "Pants",
        exampleBrandName: "Example: brand name",
        exampleTshirt: "Example: T-shirt",
        examplePartNumber: "Example: PN-123456",
        exampleSampleNumber: "Example: SN-123456",
        exampleRepeat: "Example: 1",
        exampleWhite: "Example: White",
        exampleFactory: "Example: factory",
        examplePatternNumber: "Example: P-123456",
        measurementItemInput: "Enter measurement item",
        exampleMeasurementItem: "Example: length",
        exampleMeasurementValue: "Example: 70.5",
      },
      specification: {
        dropFile: "Drop specification file",
        or: "or",
        selectFile: "Select file",
        brandOrCustomerName: "Brand or customer name",
        productionOrSample: "Production or sample",
        dateOrCreatedAt: "Date or created date",
        factoryName: "Factory name",
        patternNumber: "Pattern No.",
        measurementItemName: "Measurement item name",
        measurementValue: "Measurement value",
        operation: "Operation",
        csvRow: "row {{row}}",
        csvRowFallback: "row",
        validation: {
          timeRequired: "Select the sample status for samples.",
          sizeRequired: "Size is required.",
          repeatRequired: "Repeat is required.",
          itemRequired: "Item name is required.",
          itemsRequired: "Measurement items are required.",
          itemTitleRequired: "Measurement item name is required.",
          itemTitleDuplicate: "Measurement item names are duplicated.",
          itemValueInvalid: "Measurement item value is invalid.",
          brandRequired: "Brand or customer name is required.",
          repeatInvalid: "Enter repeat as a number.",
          repeatMin: "Enter repeat as 0 or greater.",
          partOrSampleRequired: "Enter either part number or sample No.",
          kindRequired: "Production or sample is required.",
          kindInvalid: "Production or sample contains an invalid value.",
          invalidDesignedAt: "Date or created date is invalid. Check the date format.",
          designedAtRequired: "Date or created date is required.",
          headerMissing: "The CSV header is missing required columns.",
          headerInvalid: "The CSV header contains invalid column names.",
          partNumberInvalid: "Part number can contain only half-width alphanumerics, hyphens, and underscores.",
          sampleNumberInvalid: "Sample No. can contain only half-width alphanumerics, hyphens, and underscores.",
          patternNumberInvalid: "Pattern No. can contain only half-width alphanumerics, hyphens, and underscores.",
          itemValueRequired: "Measurement item value is required.",
          itemValueMin: "Measurement item value must be 0 or greater.",
        },
      },
      drawing: {
        mode: "Drawing mode",
        moveMode: "Move mode",
        moving: "Drawing",
        moveHelpLabel: "Move:",
        moveHelp: "Space + drag or middle mouse button + drag",
        zoomHelpLabel: "Zoom:",
        zoomHelp: "{{modifier}} key + mouse wheel",
        lineColor: "Line color",
        measurementPoint: "Measurement point",
        deleteItem: "Delete item",
      },
      sizeGroups: {
        ladiesAndMens: "Ladies / Mens",
        kids: "Kids",
        mailOrderBrand: "Mail order brand",
        freeSize: "Free size",
      },
    } as const;
